import { useEffect, useRef, useState } from "react";
import {
  BtnContainer,
  CanvasContainer,
  CapturaCamaraContainer,
  ContainerCanvasAndBtn,
  RightControls,
} from "./localStyle";
import { getLocalStorage } from "global/utils/safeJsonParse";

// CapturaCamara: usa getUserMedia para mostrar video y pintar a canvas con zoom + cuenta regresiva
// onCapture(dataURL) retorna la imagen capturada como dataURL
const CapturaCamara = ({ onCapture, step, setStep }) => {
  // Estado de cuenta regresiva y zoom de la cámara
  const [second, setSecond] = useState(3);
  const [scale, setScale] = useState(1);
  const [active, setActive] = useState(false);

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const idTerminal = getLocalStorage("idTerminal");

  useEffect(() => {
    let cancelled = false;
    let localStream = null;

    const init = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });

        // Si el componente se desmontó mientras esperábamos getUserMedia,
        // cerrar el stream acá mismo para que no quede zombie ocupando la
        // cámara (la próxima apertura fallaría o mostraría frame negro).
        if (cancelled) {
          stream.getTracks().forEach((t) => t.stop());
          return;
        }

        localStream = stream;
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          await videoRef.current.play();
        }
      } catch (e) {
        console.error("[CheckinQR] CapturaCamara: getUserMedia falló", e);
      }
    };
    init();
    return () => {
      cancelled = true;
      // Cerrar lo que haya: local (si init ya resolvió) o ref (por si el
      // cleanup corre antes de que init termine de asignar).
      const streamActual = localStream || streamRef.current;
      if (streamActual) {
        streamActual.getTracks().forEach((t) => t.stop());
      }
      streamRef.current = null;
    };
  }, []);


  const capturarImagen = () => {
    setActive(true);

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = 640;
    canvas.height = 480;

    let newTime = second;
    const interval = setInterval(() => {
      newTime = newTime - 1;
      setSecond(newTime);
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      setSecond(3);
      setActive(false);
      const x = scale === 1 ? 0 : (640 * -scale) / 2 + 320;
      const y = scale === 1 ? 0 : (480 * -scale) / 2 + 240;
      ctx.drawImage(video, x, y, 640 * scale, 480 * scale);
      setStep(1);
    }, 3000);
  };

  const zoomIn = () => {
    if (scale < 3) setScale(scale + 0.5);
  };
  const zoomOut = () => {
    if (scale > 1) setScale(scale - 0.5);
  };
  const handleCancelar = () => {
    setStep(0);
    const canvas = canvasRef.current;
    canvas.width = 0;
  };
  const handleAceptar = () => {
    const canvas = canvasRef.current;
    const dataURL = canvas.toDataURL();
    onCapture && onCapture(dataURL);
    setStep(0);
    canvas.width = 0;
  };

  return (
    <CapturaCamaraContainer>
      <ContainerCanvasAndBtn>
        <CanvasContainer $isTerminal={idTerminal} $active={active} $scale={scale}>
          <video
            autoPlay
            playsInline
            muted
            width={640}
            height={480}
            ref={videoRef}
          />
          <canvas
            className="canvasCaptura"
            width={640}
            height={480}
            ref={canvasRef}
          ></canvas>
          <div className="background-second">
            <span className="second-back">{second}</span>
          </div>
        </CanvasContainer>
        <RightControls>
          {step === 0 ? (
            <>
              <button
                onClick={zoomIn}
                className="btn-circle bgc-primary c-white"
              >
                <span>+</span>
              </button>
              <button
                onClick={zoomOut}
                className="btn-circle bgc-primary c-white"
              >
                <span>-</span>
              </button>
              <button
                className="btn-tomar-foto bgc-primary c-white"
                onClick={capturarImagen}
              >
                Tomar Foto
              </button>
            </>
          ) : (
            <>
              <button
                className="btn-ok bgc-danger c-white"
                onClick={handleCancelar}
              >
                No
              </button>
              <button
                className="btn-ok bgc-broccoli c-white"
                onClick={handleAceptar}
              >
                Si
              </button>
            </>
          )}
        </RightControls>
      </ContainerCanvasAndBtn>
      <BtnContainer></BtnContainer>
    </CapturaCamaraContainer>
  );
};

export default CapturaCamara;
